import { HIDDEN_USERS_KEY } from 'hb-react/shared/constants/storageKeys';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const getBlockedUserIds = () =>
  JSON.parse(localStorage?.getItem(HIDDEN_USERS_KEY) || null) || [];

export const blockUser = (userId) => {
  const newStorage = getBlockedUserIds().concat(userId);

  localStorage?.setItem(
    HIDDEN_USERS_KEY,
    JSON.stringify([...new Set(newStorage)]),
  );

  axios.post(Routes.hide_user_publications_path(), { user_id: userId });

  return newStorage;
};

export const unblockUser = (userId) => {
  const newStorage = getBlockedUserIds().filter((id) => id !== userId);

  localStorage?.setItem(
    HIDDEN_USERS_KEY,
    JSON.stringify([...new Set(newStorage)]),
  );

  axios.delete(Routes.hide_user_publication_path(userId));

  return newStorage;
};
